import { render, staticRenderFns } from "./LoginCustomer.vue?vue&type=template&id=16c73ebb&scoped=true&"
import script from "./LoginCustomer.vue?vue&type=script&lang=js&"
export * from "./LoginCustomer.vue?vue&type=script&lang=js&"
import style0 from "./LoginCustomer.vue?vue&type=style&index=0&id=16c73ebb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c73ebb",
  null
  
)

export default component.exports